/*
 * @Author:
 * @LastEditTime: 2023-04-20 09:53:17
 * @Description:
 */
import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StdAttributeBusinessOperation {
  static async getPresentationType() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdAttributeBusinessOperation/get_presentation_type')
    )
    return Callback(err, res)
  }
  static async getOperationCategory() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdAttributeBusinessOperation/get_operation_category')
    )
    return Callback(err, res)
  }
  static async getParameterType() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdAttributeBusinessOperationParameter/get_parameter_type')
    )
    return Callback(err, res)
  }
  static async save(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdAttributeBusinessOperation', payload)
    )
    return Callback(err, res)
  }
  static async update(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/StdAttributeBusinessOperation', payload)
    )
    return Callback(err, res)
  }
  static async find(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdAttributeBusinessOperation?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdAttributeBusinessOperation', payload)
    )
    return Callback(err, res)
  }
}
